import type { CTAContent } from '@mawkaa/types';
import { Button } from '@mawkaa/ui';
import { cn } from '@mawkaa/ui';

interface CTABlockProps {
  content: CTAContent;
  isEditing?: boolean;
}

export function CTABlock({ content, isEditing }: CTABlockProps) {
  const { title, description, buttons = [], style = 'centered', backgroundImage } = content;

  return (
    <section
      className={cn(
        'px-4 py-16 relative',
        !backgroundImage && 'bg-primary text-white'
      )}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {backgroundImage && <div className="absolute inset-0 bg-primary/80" />}

      <div className={cn(
        'relative z-10 max-w-4xl mx-auto',
        style === 'centered' && 'text-center',
        style === 'split' && 'flex items-center justify-between'
      )}>
        <div className={style === 'split' ? 'max-w-xl' : ''}>
          <h2 className="text-3xl font-bold mb-4">
            {title || (isEditing ? 'Votre appel à l\'action' : '')}
          </h2>
          {description && (
            <p className="text-lg opacity-90 mb-8">{description}</p>
          )}
        </div>

        {buttons.length > 0 && (
          <div className={cn(
            'flex flex-wrap gap-4',
            style === 'centered' && 'justify-center',
            style === 'split' && 'ml-8'
          )}>
            {buttons.map((button, index) => (
              <Button
                key={index}
                variant={button.variant === 'primary' ? 'secondary' : 'outline'}
                size="lg"
              >
                {button.text}
              </Button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
